import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreOfferTile as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    getButtonExpiringText: () => <>Expiring soon</>,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
